import { IEducationalScenarioItemList } from "../../educational-scenario-items";
import { createApiQueryHook, IApiQueryFunction, IPaginateable, mapPagination } from "../../utils/api";
import { serialize } from "../../utils/url";

export type IEducationalScenarioItemListQueryParameters = IPaginateable;

export type IEducationalScenarioItemListQueryResult = IEducationalScenarioItemList;

export const educationalScenarioItemListQuery: IApiQueryFunction<IEducationalScenarioItemListQueryParameters> = ({
    pagination,
}) => {
    return {
        method: "GET",
        url: `/educational_scenario_items${serialize({ ...mapPagination(pagination) }, true)}`,
    };
};

export const useEducationalScenarioItemListQuery = createApiQueryHook<
    IEducationalScenarioItemListQueryParameters,
    IEducationalScenarioItemListQueryResult
>(educationalScenarioItemListQuery);
